<dx-scroll-view class="view-wrapper-scroll">
	<div class="view-wrapper">
		<dx-toolbar class="toolbar-details theme-dependent">
			<dxi-item 
				location="before"
				locateInMenu="never"
				widget="dxButton"
				showText="inMenu"
				[options]="{
					text: 'Vissza',
					icon: 'arrowleft',
					onClick: handleBackwards,
					stylingMode: 'text'
				}"
			></dxi-item>
			<dxi-item 
				location="before" 
				text="Munkaigény">
			</dxi-item>

			<dxi-item 
				location="after" 
				locateInMenu="auto" 
				[visible]="!isEditing && !isReadOnly">
				<dx-button
					text="Szerkesztés"
					icon="edit"
					stylingMode="contained"
					type="default"
					(onClick)="handleEditButtonClick()"
				></dx-button>
			</dxi-item>
			<dxi-item 
				location="after" 
				locateInMenu="never" 
				[visible]="isEditing && !isReadOnly">
				<dx-button
					text="Mentés"
					stylingMode="contained"
					type="default"
					(onClick)="handleSaveButtonClick($event)"
				></dx-button>
			</dxi-item>
			<dxi-item 
				location="after" 
				locateInMenu="auto" 
				[visible]="isEditing && !isReadOnly">
				<dx-button
					text="Mégsem"
					stylingMode="outlined"
					type="normal"
					(onClick)="handleCancelButtonClick()"
				></dx-button>
			</dxi-item>
			<dxi-item
				location="after"
				locateInMenu="auto"
				widget="dxButton"
				showText="inMenu"
				[visible]="!isEditing && !isReadOnly"
				[options]="{
					text: 'Törlés',
					icon: 'trash',
					onClick: handleDelete,
					stylingMode: 'text'
				}"
			></dxi-item>
			<dxi-item
				location="after"
				locateInMenu="auto"
				widget="dxButton"
				showText="inMenu"
				[visible]="!isEditing"
				[options]="{
					text: 'Frissítés',
					icon: 'refresh',
					onClick: handleRefresh,
					stylingMode: 'text'
				}"
			></dxi-item>
		</dx-toolbar>

		<div #workRequestPanel class="panels">
			<div class="left">
				<dx-validation-group>
					<dx-form
						*ngIf="workRequest"
						class="plain-styled-form"
						[class.view-mode]="!isEditing"
						[screenByWidth]="getSizeQualifier"
					>
						<dxi-item itemType="group">
							<dxo-col-count-by-screen
								[xs]="1"
								[sm]="2"
								[md]="3"
								[lg]="3"
							></dxo-col-count-by-screen>
							<dxi-item cssClass="accent">
								<div *dxTemplate>
									<form-item-date
										label="Bejelentés dátuma"
										[isEditing]="false"
										[(value)]="workRequest.createdDate"
									></form-item-date>
								</div>
							</dxi-item>

							<dxi-item cssClass="accent">
								<div *dxTemplate>
									<dx-select-box
										label="Állapot"
										stylingMode="filled"
										valueExpr="id"
										displayExpr="name"			
										[readOnly]="true"
										[dataSource]="workRequestStatusIdNameMap"
										[elementAttr]="{ class: 'form-editor' }"
										[inputAttr]="{ class: 'form-editor-input' }"
										[value]="workRequest.statusId"
									></dx-select-box>
								</div>
							</dxi-item>
						</dxi-item>

						<dxi-item cssClass="accent">
							<div *dxTemplate>
								<form-textbox
									label="Tárgy"
									[isEditing]="isEditing"
									[(value)]="workRequest.subject"
								></form-textbox>
							</div>
						</dxi-item>
						<dxi-item cssClass="accent">
							<div *dxTemplate>
								<dx-lookup
									label="Partner"
									stylingMode="filled"
									displayExpr="name"
									valueExpr="id"									
									[dataSource]="customers"
									[elementAttr]="{ class: 'form-editor' }"
									[inputAttr]="{ class: 'form-editor-input' }"
									[(value)]="workRequest.customerId"
								></dx-lookup>
							</div>
						</dxi-item>
		
						<dxi-item itemType="group">
							<dxo-col-count-by-screen
								[xs]="1"
								[sm]="2"
								[md]="3"
								[lg]="3"
							></dxo-col-count-by-screen>
							<!-- <dxi-item cssClass="accent">
								<div *dxTemplate>
									<form-textbox
										label="Igényelt munkatárs"
										[(value)]="workRequest.preferedWorkerName"
										[isEditing]="isEditing"
									></form-textbox>
								</div>
							</dxi-item> -->
				
							<!-- <dxi-item cssClass="accent">
								<div *dxTemplate>
									<form-item-date
										label="Legkorábbi kezdő dátum"
										[isEditing]="isEditing"
										[(value)]="workRequest.earliestStartDate"
									></form-item-date>
								</div>
							</dxi-item> -->
				
							<!-- <dxi-item cssClass="accent">
								<div *dxTemplate>
									<form-item-date
										label="Legkésőbbi befejezési dátum"
										[isEditing]="isEditing"
										[(value)]="workRequest.latestEndDate"
									></form-item-date>
								</div>
							</dxi-item> -->
						</dxi-item>
						<dxi-item cssClass="accent">
							<div *dxTemplate>
								<dx-text-area
									label="Leírás"
									stylingMode="filled"
									[autoResizeEnabled]="true"
									[minHeight]="50"
									[maxHeight]="400"								[readOnly]="!isEditing"
									[(value)]="workRequest.description"
									[elementAttr]="{ class: 'form-editor' }"
									[inputAttr]="{ class: 'form-editor-input' }"
								></dx-text-area>
							</div>
						</dxi-item>
						<dxi-item 
							*ngIf="workRequest.statusId === workRequestStatusId.Rejected"
							cssClass="accent">
							<div *dxTemplate>
								<dx-text-area
									label="Elutasítás oka"
									stylingMode="filled"
									[autoResizeEnabled]="true"
									[readOnly]="!isEditing"
									[(value)]="workRequest.rejectionReason"
									[elementAttr]="{ class: 'form-editor' }"
									[inputAttr]="{ class: 'form-editor-input' }"
								></dx-text-area>
							</div>
						</dxi-item>
						<dxi-item cssClass="accent">
							<div *dxTemplate>
								<dx-file-uploader
									label="Csatolmányok"
									[accept]="allowedFileExtensions.join(',')"
									[allowCanceling]="true"
									[invalidFileExtensionMessage]="'Érvénytelen fájltípus'"
									[invalidMaxFileSizeMessage]="'A fájl túl nagy, a maximális méret 10 MB'"
									[labelText]="''"
									[maxFileSize]="maxFileSize"
									[multiple]="true"
									[readOnly]="!isEditing"
									[readyToUploadMessage]="''"
									[selectButtonText]="'Fájlok kiválasztása'"
									[showFileList]="true"
									[uploadAbortedMessage]="'Feltöltés megszakítva'"
									[uploadButtonText]="'Feltöltés'"
									[uploadedMessage]="'Feltöltés sikeres'"
									[uploadFailedMessage]="'Feltöltés sikertelen'"
									[uploadMode]="'useButtons'"
									[(value)]="files"
									(onContentReady)="handleContentReady($event)"
									(onValueChanged)="handleFileUploaderValueChanged($event)"
								></dx-file-uploader>
							</div>
						</dxi-item>
						<!-- <dxi-item cssClass="accent">
							<div *dxTemplate>
								<input #fileInput type="file" style="display: none" (change)="handleFileSelected($event)" />
								<dx-button text="Fájlok kiválasztása" (onClick)="fileInput.click()"></dx-button>

								<dx-data-grid
									*ngIf="attachments && attachments.length > 0"
									[dataSource]="attachments"
									[showColumnHeaders]="false"
									[allowColumnReordering]="true"
									[allowColumnResizing]="true"
									>
									<dxi-column 
										dataField="fileName" 
										caption="Fájl neve" 
										[width]="200"/>
								</dx-data-grid>
							</div>
						</dxi-item> -->
					</dx-form>
				
					<dx-load-panel
						content="#workRequestPanel"
						[visible]="isLoading"
						[showPane]="true"
						[position]="{ of: '#workRequestPanel' }"
						[shading]="true"
						message=""
					></dx-load-panel>
				</dx-validation-group>
			</div>
		</div>
	</div>
</dx-scroll-view>
